import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import Card from "../ui/Card";
import { EmptyState } from "../ui/Table";
import { BarChart3 } from "lucide-react";
import { getCashVsExpectedSeries } from "../../lib/calculations";
import { formatUSD } from "../../lib/formatters";

export default function RevenueChart({ payments }) {
  const data = getCashVsExpectedSeries(payments, 6, 6);
  const empty = data.every((d) => d.cash === 0 && d.expected === 0);
  return (
    <Card title="Cash collected vs Expected revenue">
      {empty ? (
        <EmptyState icon={BarChart3} title="No revenue data yet" message="Record payments or load sample data to populate this chart." />
      ) : (
        <div style={{ width: "100%", height: 280 }}>
          <ResponsiveContainer>
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} />
              <XAxis dataKey="month" tick={{ fontSize: 11, fill: "#6d7a97" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 11, fill: "#6d7a97" }} axisLine={false} tickLine={false} tickFormatter={(v) => formatUSD(v, { compact: true })} />
              <Tooltip formatter={(v) => formatUSD(v)} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="cash" name="Cash collected" fill="#16a34a" radius={[4, 4, 0, 0]} />
              <Bar dataKey="expected" name="Expected revenue" fill="#3480f1" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </Card>
  );
}
